import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const CAPCITO_ONBOARDING = (params) => { return URI(`${API_BASE}/api/v2/marketplace/capcito/onboarding/`).addSearch(params) }
export const CAPCITO_VALIDATE = () => { return URI(`${API_BASE}/api/v2/marketplace/capcito/onboarding/validate/`) }
